<template>
  <div class="xd-notice" v-html="content"></div>
</template>

<script>
export default {
  name: 'XDNotice',
  props: {
    name: String,
    content: String,
    duration: Number,
    onClose: Function,
  },
  data() {
    this.closeTimer = null;

    return {};
  },

  mounted() {
    this.clearCloseTimer();
    if (this.duration !== 0) {
      this.closeTimer = setTimeout(this.close, this.duration * 1000);
    }
  },

  methods: {
    clearCloseTimer() {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
    },

    close() {
      this.clearCloseTimer();
      this.onClose();
      this.$parent.$parent.close(this.name);
    },
  },
};
</script>

<style lang="scss" scoped>
.xd-notice {
  margin: 8px 0;
  padding: 8px 16px;
  border-radius: 20px;
  background: rgba(0,0,0,0.7);
  color: #ffffff;
  font-size: 14px;
}
</style>